<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Ubah nomor Whatsapp`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black">
                    <div class="m-d-16">
                        <SOInputTelp
                            id="edit-wa"
                            title="Nomor Whatsapp"
                            :required="true"
                            :country-code="dataDevice.country_code"
                            placeholder="8123456789"
                            :value="posted.nomor"
                            @input="onInput"
                            @country-code="setCountryCode"
                        />
                        <ErrorMessage class="error" label="Nomor Whatsapp" :validation="$v.posted.nomor" />
                    </div>
                    <div>
                        <label class="m-d-0 f-regular f-14 f-c-midgrey">
                            Mengubah nomor WA akan memutus sambungan dari nomor yang lama, kemudian melakukan scan ulang
                            QR code di nomor yang baru.
                        </label>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <SOButton
                        :primary="true"
                        :full="true"
                        :text="'Berikutnya'"
                        :id="`do-update-nomor`"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="saveUpdate"
                    />
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Batal'"
                        :id="'batal-update-nomor'"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="back"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputTelp from "@/so-components/global/input/SOInputTelp.vue";
import ErrorMessage from "@/component-items/ErrorMessage";
import { minLength, required } from "vuelidate/lib/validators";

import { moduleName } from "../../store/state";

export default {
    name: "ModalGantiNomor",
    components: {
        SOSlotModal,
        SOButton,
        SOInputTelp,
        ErrorMessage,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat",
            modalId: "modal-ganti-nomor",
            posted: {
                iddevice: "",
                type: "number",
                nomor: "",
                nama: "",
                country_code: "62",
                auto_renewal: null,
            },
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.init();
    },
    validations: {
        posted: {
            nomor: {
                required,
                minLength: minLength(8),
            },
        },
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.$router.push({
                    name: "wa_autosender.connect_perangkat",
                    params: { id_device: this.dataDevice.iddevice },
                });
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            dataDevice: "dataDevice",
            isFetching: "isFetching",
            response: "response",
        }),
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            updateDeviceDetail: `${moduleName}/updateDeviceDetail`,
            getDetailDevice: `${moduleName}/getDetailDevice`,
            resetListPerangkat: `${moduleName}/resetListPerangkat`,
            setIsconnectDevice: `${moduleName}/setIsconnectDevice`,
        }),
        init() {
            this.posted.iddevice = this.dataDevice.iddevice;
            this.posted.nomor = this.dataDevice.nomor;
            this.posted.nama = this.dataDevice.nama;
            this.posted.auto_renewal = this.dataDevice.auto_renewal;
            this.posted.country_code = this.dataDevice.country_code;
        },
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        onInput(val) {
            this.posted.nomor = val;
        },
        setCountryCode(val) {
            this.posted.country_code = val;
        },
        isValid() {
            let { nomor } = this.$v.posted;
            nomor.$touch();

            return nomor.$invalid;
        },
        saveUpdate() {
            if (this.isValid()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }
            let postUpdate = {
                ...this.posted,
            };

            if (postUpdate.nomor === this.dataDevice.nomor) {
                this.$toast.error("Nomor tidak boleh sama dengan sebelumnya");
                return;
            }

            this.updateDeviceDetail(postUpdate)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.getDetailDevice({ id_mesin: data.iddevice });
                        this.setIsconnectDevice({ iddevice: data.iddevice, status: 0 ,multi:1});
                        this.resetListPerangkat();
                    } else {
                        this.setResponse(resulter.errorResult(msg));
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
    },
};
</script>
<style scoped>
.diskon-percent {
    padding: 2px 8px;
    border-radius: 25px;
    background-color: #ededed;
    width: fit-content;
}

.paket-wa {
    max-width: unset;
}
@media (min-width: 320px) {
    .paket-wa {
        max-width: 170px;
    }
}

@media (min-width: 360px) {
    .paket-wa {
        max-width: 210px;
    }
}

@media (min-width: 400px) {
    .paket-wa {
        max-width: 250px;
    }
}
</style>
